import request from '@/utils/request'

export function getLocationsPulldown() {
  return request({
    url: 'locations/pulldown',
    method: 'get'
  })
}

export function getLocations() {
  return request({
    url: 'locations/list',
    method: 'get'
  })
}

export function getLocationDetails(slug, dateFrom, dateTo) {
  return request({
    url: 'locations/' + slug + '?date_from=' +  dateFrom + '&date_to=' +  dateTo,
    method: 'get'
  })
}

export function getSeatTypes(locationId) {
  return request({
    url: 'seat-types/' + locationId,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/location.js